export default "__VITE_ASSET__klRdc5rX__"